import { FC, SVGProps } from "react";

const VectorFloor: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="407"
      height="440"
      viewBox="0 0 407 440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M406.803 429.135C407.281 430.131 406.861 431.325 405.865 431.803L389.636 439.589C388.64 440.067 387.446 439.647 386.968 438.651C386.49 437.655 386.91 436.461 387.906 435.983L402.332 429.062L395.411 414.636C394.933 413.64 395.353 412.446 396.349 411.968C397.345 411.49 398.539 411.91 399.017 412.906L406.803 429.135ZM4.07101 1.05857C1.32245 94.8777 77.3618 312.692 405.663 428.113L404.337 431.887C74.6214 315.969 -2.73358 96.7312 0.0727234 0.941432L4.07101 1.05857Z"
        fill="white"
      />
    </svg>
  );
};

export default VectorFloor;
